import styled, { keyframes } from 'styled-components'

const fadeInOut = keyframes`
  0%, 100% { opacity: 0; transform: translateY(10px) }
  20%, 80% { opacity: 1; transform: translateY(0) }
`

export const Container = styled.div`
  width: 100%;
  padding: 40px;
  display: flex;
  justify-content: center;
  align-items: center;

`

export const QuoteWrapper = styled.div`
  max-width: 800px;
  padding: 30px 40px;
  border-radius: 12px;
  background: rgba(255, 255, 255, 0.03);
  border: 1px solid rgba(255, 0, 255, 0.15);
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.2), 0 0 15px rgba(255, 0, 255, 0.1);
  animation: ${fadeInOut} 10s ease-in-out infinite;
`

export const QuoteText = styled.div`
  font-size: 20px;
  line-height: 1.6;
  color: rgba(255, 255, 255, 0.9);
  margin-bottom: 16px;
  font-style: italic;
  position: relative;
  padding-left: 24px;
  
  &::before {
    content: '"';
    position: absolute;
    left: 0;
    top: -2px;
    font-size: 36px;
    color: #00ffff;
    opacity: 0.8;
  }
`

export const QuoteAuthor = styled.div`
  font-size: 16px;
  color: #00ffff;
  text-align: right;
  font-weight: 500;
  opacity: 0.8;
  
  &::before {
    content: '— ';
  }
`
